<div class="container" style="margin-top: 6rem;">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body p-4">


            <div *ngIf="!showLoginForm && user">
              <div class="text-center mb-4">
                <ng-container *ngIf="user.user_login === 'whatsapp'">
                  <div class="mt-3 mb-5 text-center">
                    <h3 style="color:var(--warna-2)">Welcome back, {{ user.name }}</h3>
                  </div>

                  <div class="rounded-circle mb-3 text-center">
                    <img 
                      [src]="user.photo" 
                      alt="User Photo" 
                      class="rounded-circle" 
                      *ngIf="user.photo" 
                      (error)="handleImageError($event)" 
                      style="width: 7vw;"
                    >
                    <i *ngIf="!user.photo || isImageError" class="fas fa-user-circle" style="font-size: 4rem; color:var(--warna-2)"></i>
                  </div>

                  <div class="email-display-container" style="position: relative; display: inline-block; padding: 10px; border-radius: 5px;">
                    <span style="color: var(--warna-2);">{{ getMaskedPhone(user.user_wa) }}</span>
                    <button 
                      (click)="logout2($event)"
                      style="position: absolute; top: 0; right: -1vw; border: none; background: none; font-size: 1rem; cursor: pointer; color: var(--warna-2);">
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </div>

                  <div class="mb-3">     
                  <small class="form-text text-muted mt-2">
                    Continue to login with phone number. A verification code will be sent to your <strong>WhatsApp</strong>.
                  </small>
                </div>


                <form [formGroup]="phoneForm" (ngSubmit)="lanjut()">
          
                  <div class="mb-3" style="display: none;">
                    <input 
                      #phoneInput
                      type="tel"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      [ngClass]="{'is-invalid': submitted && phoneForm.get('phone')?.invalid}"
                      placeholder="812345678"
                    >
                    <div class="text-danger text-start" *ngIf="submitted">
                      <div *ngIf="hasError(phoneForm, 'phone', 'required')">Phone number is required</div>
                      <div *ngIf="hasError(phoneForm, 'phone', 'pattern')">Please enter a valid phone number</div>
                    </div>
                  </div>
                      <button type="submit" class="btn btn-primary w-100" [disabled]="isLoading">
                        <span *ngIf="!isLoading">Continue</span>
                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </button>
                </form>

                  <div class="text-end">
                    <span (click)="logout2($event)" class="link-buatan link-secondary">Use another account</span>
                  </div>
                </ng-container>
              </div>
            </div>

             
      <!-- //--------------------------------------------------------------------------------- -->

              <!-- Cek apakah data pengguna ada dan tampilkan informasi pengguna -->
              <div *ngIf="step === 'existing' && !showLoginForm && user" class="existing-step">
                <div class="text-center mb-4">
    
                  <ng-container *ngIf="user.user_login === 'google';else second">\
                   
                    <div class="mt-3 mb-5 text-center">
                      <h3 style="color:var(--warna-2)">Account Exists</h3>
                      <span>Looks like you already have an account. Please log in instead.</span>
                    </div>

                    <div class="mb-3 text-start">
                      <span class="link-buatan" (click)="switchToEmailLogin()">  <i class="fa fa-chevron-left"></i> </span>
                    </div>

    
    
                    <div class="rounded-circle mb-3 text-center">
                      <img 
                        [src]="user.photo" 
                        alt="User Photo" 
                        class="rounded-circle" 
                        *ngIf="user.photo" 
                        (error)="handleImageError($event)" 
                        style="width: 7vw;"
                      >
                      <i *ngIf="!user.photo || isImageError" class="fas fa-user-circle" style="font-size: 5rem; color:var(--warna-2)"></i>
                    </div>
    
                    <div class="email-display-container" style="position: relative; display: inline-block; padding: 10px; border-radius: 5px;">
                      <span style="color: var(--warna-2);">{{ getMaskedEmail(user.email) }}</span>
                      <button 
                        (click)="logout2($event)"
                        style="position: absolute; top: 0; right: -1vw; border: none; background: none; font-size: 1rem; cursor: pointer; color: var(--warna-2);">
                        <i class="fa fa-times-circle"></i>
                      </button>
                    </div>
    
    
                    <div class="d-grid gap-2">   
                    <button type="button" class="btn btn-outline-secondary" (click)="handleGoogleLogin()">
                    <i class="fab fa-google me-2"></i> Continue with Google
                    </button>
    
                  <div class="text-end">
                    <span (click)="logout2($event)" class="link-buatan link-secondary">Use another account</span>
                  </div>
                  </div>
    
                  </ng-container>
                  <ng-template #second>
                      <ng-container *ngIf="user.user_login === 'facebook'">
                        <div class="mt-3 mb-5 text-center">
                          <h3 style="color:var(--warna-2)">Account Exists</h3>
                          <span>Looks like you already have an account. Please log in instead.</span>
                        </div>
    
                        <div class="mb-3 text-start">
                          <span class="link-buatan" (click)="switchToEmailLogin()">  <i class="fa fa-chevron-left"></i> </span>
                        </div>
    


                        <div class="rounded-circle mb-3 text-center">
                          <img 
                            [src]="user.photo" 
                            alt="User Photo" 
                            class="rounded-circle" 
                            *ngIf="user.photo" 
                            (error)="handleImageError($event)" 
                            style="width: 7vw;"
                          >
                          <i *ngIf="!user.photo || isImageError" class="fas fa-user-circle" style="font-size: 4rem; color:var(--warna-2)"></i>
                        </div>
    
                        <div class="email-display-container" style="position: relative; display: inline-block; padding: 10px; border-radius: 5px;">
                          <span style="color: var(--warna-2);">{{ user.name }}</span>
                          <button 
                            (click)="logout2($event)"
                            style="position: absolute; top: 0; right: -1vw; border: none; background: none; font-size: 1rem; cursor: pointer; color: var(--warna-2);">
                            <i class="fa fa-times-circle"></i>
                          </button>
                        </div>
    
                        <div class="d-grid gap-2">   
                        <button type="button" class="btn btn-outline-secondary" (click)="loginWithFacebook()">
                        <i class="fab fa-facebook me-2"></i> Continue with Facebook
                        </button>
    
                      <div class="text-end">
                        <span (click)="logout2($event)" class="link-buatan link-secondary">Use another account</span>
                      </div>
                      </div>
                      </ng-container>
                  </ng-template>
                </div>
              </div>

      <!-- --------------------------------------------------------------------------------- -->
                 

                  <div *ngIf="step === 'phone' && showLoginForm" class="phone-step">
                    <!-- Form Login Phone -->
                    <form [formGroup]="phoneForm" (ngSubmit)="onContinueWithPhone()">
                      <div class="mt-3 mb-5 text-center">
                        <h3 style="color:var(--warna-2)">Log In or Sign Up</h3>
                      </div>
                  
                      <!-- Input Nomor Telepon -->
                      <div class="mb-3">
                        <input 
                          #phoneInput
                          type="tel"
                          class="form-control"
                          id="phone"
                          formControlName="phone"
                          [ngClass]="{'is-invalid': submitted && phoneForm.get('phone')?.invalid}"
                          placeholder="812345678"                       
                        >
                        <div class="text-danger" *ngIf="submitted">
                          <div *ngIf="hasError(phoneForm, 'phone', 'required')">Phone number is required</div>
                          <div *ngIf="hasError(phoneForm, 'phone', 'pattern')">Please enter a valid phone number</div>
                        </div>
                        <small class="form-text text-muted mt-2">
                          Continue to login with your phone number. A verification code will be sent to your <strong>WhatsApp</strong>.
                        </small>
                      </div>
                  
                      <button type="submit" class="btn btn-primary w-100" [disabled]="isLoading">
                        <span *ngIf="!isLoading">Continue</span>
                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </button>
                    </form>
                  </div>


      <div *ngIf="step === 'otp' && showLoginForm" class="otp-step">
            <!-- Form Verifikasi OTP -->
          <form [formGroup]="otpForm" (ngSubmit)="onVerifyOtp()">
              <div class="mt-3 mb-5 text-center">
                <h3 style="color:var(--warna-2)">Verify OTP</h3>
              </div>
              
              <div class="mb-3">
                  <span class="link-buatan" (click)="switchToEmailLogin()">  <i class="fa fa-chevron-left"></i> </span>
              </div>


              <!-- Input OTP -->
              <div class="mb-3">
                <input 
                  type="text"
                  class="form-control"
                  id="otp"
                  formControlName="otp"
                  [ngClass]="{'is-invalid': submitted && otpForm.get('otp')?.invalid}"
                  placeholder="Enter OTP"
                >
                <div class="text-danger" *ngIf="submitted">
                  <div *ngIf="hasError(otpForm, 'otp', 'required')">OTP is required</div>
                  <div *ngIf="hasError(otpForm, 'otp', 'pattern')">Please enter a valid 6-digit OTP</div>
                </div>
                <small class="form-text text-muted mt-2">
                  Enter the 6-digit code sent to your <strong>WhatsApp</strong>.
                </small>
              </div>
          
              <button type="submit" class="btn btn-primary w-100" [disabled]="isLoading">
                <span *ngIf="!isLoading">Login</span>
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
          
              <!-- Countdown Timer -->
              <div *ngIf="remainingTime > 0" class="text-center mt-3">
                <small class="text-muted">Resend to WhatsApp : <strong>{{ formatTime(remainingTime) }}</strong></small>
              </div>
          
              <!-- Link untuk Request OTP Ulang -->
              <div *ngIf="remainingTime === 0" class="text-center mt-3">
                <span class="link-buatan" (click)="onRequestOtpAgain()">Resend to WhatsApp</span>
                <!-- <button class="btn btn-link" (click)="onRequestOtpAgain()">Request OTP Again</button> -->
              </div>
          </form>
      </div>


      <div *ngIf="step === 'register' && showLoginForm" class="register-step">
        <form [formGroup]="registerForm" (ngSubmit)="onCompleteRegistration()">
          <div class="mt-3 mb-5 text-center">
            <h3 style="color:var(--warna-2)">Finishing Signing Up</h3>
          </div>

        <div class="mb-3">
            <span class="link-buatan" (click)="switchToEmailLogin()">  <i class="fa fa-chevron-left"></i> </span>
        </div>

          <!-- Name Input -->
          <div class="mb-3">
            <input 
              type="text" 
              class="form-control" 
              id="name"
              formControlName="name"
              [ngClass]="{'is-invalid': submitted && registerForm.get('name')?.invalid}"
              placeholder="Full Name"
            >
            <div class="text-danger" *ngIf="submitted">
              <div *ngIf="hasError(registerForm, 'name', 'required')">Please enter your name</div>
            </div>
          </div>

          <!-- Email Input -->
          <div class="mb-3">
            <input 
              type="email" 
              class="form-control" 
              id="email"
              formControlName="email"
              [ngClass]="{'is-invalid': submitted && (hasError(registerForm, 'email', 'required') || hasError(registerForm, 'email', 'email'))}"
              placeholder="Email"
            >

            <div class="text-danger" *ngIf="submitted">
              <div *ngIf="hasError(registerForm, 'email', 'required')">Please enter your email</div>
              <div *ngIf="hasError(registerForm, 'email', 'email')">Please enter a valid email</div>
            </div>
          </div>

          <!-- Google reCAPTCHA -->
          <div class="mb-3">
            <ngx-recaptcha2 #captchaElem
              [siteKey]= recaptchaSiteKey
              formControlName="recaptcha"
              [ngClass]="{'is-invalid': submitted && registerForm.get('recaptcha')?.invalid}"                 
              >
            </ngx-recaptcha2>
            
            <div class="text-danger" *ngIf="submitted">
              <div *ngIf="hasError(registerForm, 'recaptcha', 'required')">Please verify that you are not a robot</div>
            </div>

            <!-- <div *ngIf="submitted && !recaptchaVerified" class="text-danger">
              Please verify that you are not a robot
            </div> -->
          </div>

          <button 
            type="submit" 
            class="btn btn-primary w-100" 
            [disabled]="isLoading"
          >
            <span *ngIf="!isLoading">Continue</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
        </form>
      </div>


        <ng-template *ngIf="step === 'otp' || step === 'register' || step === 'existing'; else lain">
        </ng-template>


      <ng-template #lain>
        <div *ngIf="showLoginForm"> 
            <app-login-social>
            </app-login-social>
             </div>
      </ng-template>





            </div>
            </div>
        </div>
    </div>
</div>

